import { RestAction, RestActionTypes } from '../actions/rest.actions';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ResponseState } from '../../model/response-result';

// export interface ResponseState {
//   success: boolean;
//   status: number,
//   message?: string,
//   detail?: string,
//   jumpToHome?: boolean,
//   error?: HttpErrorResponse
// }
export interface ActiveRequest {
  uid: string;
  url: string;
  timeStamp: number;
  showLoading: string | boolean;
}

export interface RestState {
  completed: number;
  total: number;
  showLoading: string | boolean;
  lastState?: ResponseState;
  activeRequests: ActiveRequest[];
}

const initialRestState: RestState = {
  completed: 0,
  total: 0,
  showLoading: false,
  activeRequests: []
};

export function restReducer(state = initialRestState, action: RestAction) {
  switch (action.type) {
    case RestActionTypes.ResetCounter:
      state = { ...initialRestState, activeRequests: [] };
      break;
    case RestActionTypes.BeginRequest:
      if (action.request) {
        state = {
          ...state,
          activeRequests: [...state.activeRequests, action.request]
        }
        // state.activeRequests = [...state.activeRequests, action.request];
      }
      state = {
        ...state,
        total: action.counting ? state.total + 1 : state.total,
        // only take the first request's showLoading
        showLoading: state.total === 0 ? (action.showLoading === 'true' || action.showLoading) : state.showLoading,
        activeRequests: [...state.activeRequests]
      };
      if (action.percent) {
        state = {
          ...state,
          total: 100,
          showLoading: true,      // display progress bar
          completed: action.percent
        };
      }


      break;
    case RestActionTypes.EndRequest:
      if (action.request) {
        const index = state.activeRequests.findIndex(p => p.uid === action.request.uid);
        if (index >= 0 && state.activeRequests.length > 0) {
          // state.activeRequests.splice(index, 1);
          state = {
            ...state,
            activeRequests: state.activeRequests.filter((req, idx) => idx != index)
          }
        }
      }
      state = {
        ...state,
        completed: state.completed + 1,
        lastState: action.payload,
        activeRequests: [...state.activeRequests]
      };
      break;
  }
  //console.log(state);
  return state;
}

export const selectFeatureState = createFeatureSelector<RestState>('rest');

export const selectProgress = createSelector(
  selectFeatureState,
  state => {
    if (state.total > 0 && state.completed === 0) {
      return '5%';
    }
    return state.total > 0 ? (state.completed * 100) / state.total + '%' : '0';
  }
);

export const selectIsProgressBar = createSelector(
  selectFeatureState,
  state => state.showLoading === true
);

export const selectLastState = createSelector(
  selectFeatureState,
  state => state.lastState
);
